module.exports = __webpack_public_path__ + "8c3758d6bbd90c3fb72df6b94ad8c63e.svg";